import script from "./project.vue?vue&type=script&setup=true&lang=js"
export * from "./project.vue?vue&type=script&setup=true&lang=js"

import "./project.vue?vue&type=style&index=0&id=08f9ed29&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f9ed29"]])

export default __exports__